// extracted by mini-css-extract-plugin
export default {"dividerBox":"ZCoreClub_dividerBox__U3Lin"};